import { Outlet } from 'react-router-dom';
import {
  BabyPage,
  HomePage,
  NewPasswordPage,
  PregnancyPage,
  ParentHoodPage,
  FamilyPage,
  OvulationTrackerPage,
  CommunityPage,
  BabyNamesPage,
  RegistryChecklistPage,
  RegistryBuilderPage,
  GrowthTrackerPage,
  BabyBlogPage,
  DueDateCalculatorPage,
  // CoursesPage,
  CourseDetailPage,
  CommunityBlogPage,
  // ViewCoursePage,
  // MyCoursesPage,
  SettingPage,
  ContactUsPage,
  AboutUsPage,
  SearchPage,
  PrivacyPolicy,
  CommunityBirthClubPage,
  PaymentPage,
  TermsOfUse,
  MobileApp,
  CreateGroup,
  GroupDetail,
  ArticlesTopics,
  ReportPage,
  SavedNames,
  Blogs,
  TopicBlog,
  DeactiveAccountPage,
  CoursesInfo,
  WeekByWeekPage,
} from './route.import';
import routeConstants from './route.constants';

const routesConfig = {
  // Private routes - require authentication
  private: [
    {
      path: routeConstants.NEW_PASSWORD,
      Component: NewPasswordPage,
    },
    // {
    //   path: routeConstants.VIEWCOURSE,
    //   Component: ViewCoursePage,
    // },
    // {
    //   path: routeConstants.MYCOURSES,
    //   Component: MyCoursesPage,
    // },
    {
      path: routeConstants.SETTING,
      Component: SettingPage,
    },
    {
      path: routeConstants.BIRTHCLUB,
      Component: CommunityBirthClubPage,
    },
    {
      path: routeConstants.CREATE_GROUP,
      Component: CreateGroup,
    },
    {
      path: routeConstants.GROUP_DETAIL,
      Component: GroupDetail,
    },
    {
      path: routeConstants.SAVED_NAMES,
      Component: SavedNames,
    },

    {
      path: routeConstants.TOPIC_BLOG,
      Component: TopicBlog,
    },
  ],

  public: [
    {
      path: '/',
      Component: Outlet,
      children: [
        {
          index: true,
          path: '/',
          Component: HomePage,  
        },
        {
          path: routeConstants.TERMS_OF_USE,
          Component: TermsOfUse,
        },
        // {
        //   path: routeConstants.COURSESINFO,
        //   Component: CoursesInfo,
        //   isHideLayout: true,
        // },
        {
          path: routeConstants.BLOGS,
          Component: Blogs,
        },
        {
          path: routeConstants.SEARCH,
          Component: SearchPage,
        },
        {
          path: routeConstants.BABY,
          Component: BabyPage,
        },
        {
          path: routeConstants.BABYNAMES,
          Component: BabyNamesPage,
        },
        {
          path: routeConstants.BABYBLOG,
          Component: BabyBlogPage,
        },
        {
          path:routeConstants.WEEKBYWEEK,
          Component:WeekByWeekPage
        },
        {
          path: routeConstants.BABY_REGISTRY_CHECKLIST,
          Component: RegistryChecklistPage,
        },
        {
          path: routeConstants.REGISTRY_BUILDER,
          Component: RegistryBuilderPage,
        },
        {
          path: routeConstants.GROWTH_TRACKER,
          Component: GrowthTrackerPage,
        },
        {
          path: routeConstants.PREGNANCY,
          Component: PregnancyPage,
        },
        {
          path: routeConstants.COMMUNITY,
          Component: CommunityPage,
        },
        {
          path: routeConstants.COMMUNITY_BLOG,
          Component: CommunityBlogPage,
        },
        {
          path: routeConstants.DUEDATECALCULATOR,
          Component: DueDateCalculatorPage,
        },
        // {
        //   path: routeConstants.COURSES,
        //   Component: CoursesPage,
        
        // },
        // {
        //   path: routeConstants.COURSEDETAIL,
        //   Component: CourseDetailPage,
        // },
        {
          path: routeConstants.CONTACTUS,
          Component: ContactUsPage,
        },
        {
          path: routeConstants.REPORT,
          Component: ReportPage,
        },
        {
          path: routeConstants.ABOUTUS,
          Component: AboutUsPage,
        },
        {
          path: routeConstants.PRIVACYPOLICY,
          Component: PrivacyPolicy,
        },
        {
          path: routeConstants.PAYMENT,
          Component: PaymentPage,
        },
        {
          path: routeConstants.PARENTHOOD,
          Component: ParentHoodPage,
        },
        {
          path: routeConstants.OVULATIONTRACK,
          Component: OvulationTrackerPage,
        },
        {
          path: routeConstants.OVULATIONTRACKER,
          Component: OvulationTrackerPage,
        },
        {
          path: routeConstants.FAMILY,
          Component: FamilyPage,
        },
        {
          path: routeConstants.MOBILE_APP,
          Component: MobileApp,
        },
        {
          path: routeConstants.ARTICLES_TOPICS,
          Component: ArticlesTopics,
        },
      ],
    },
  ],

  // Standalone routes - separate pages without main layout
  standalone: [
    {
      path: routeConstants.DEACTIVE_ACCOUNT,
      Component: DeactiveAccountPage,
    },
  ],
};

export default routesConfig;
